import React from 'react';
import { CMSContent } from '../components/cms/CMSContent';
import SEO from '../components/SEO';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-testid="privacy-page">
      <SEO
        title="Privacy Policy"
        description="TreatX Privacy Policy — how we collect, use and protect personal data across the TreatX medical-tourism platform."
        canonicalPath="/privacy"
      />
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm p-6 sm:p-8 lg:p-10">
        <CMSContent
          contentKey="privacy_policy"
          showTitle={true}
          showSummary={false}
          showLegalMetadata={true}
        />
      </div>
    </div>
  );
};

export default PrivacyPage;
